import React, {useCallback, useEffect, useState} from "react";
import ImageViewControl from "./ImageViewControl";
import pdf2Images from "../../utils/files/pdfReader";
import imageReader from "../../utils/files/imageReader";
import DropComponentTest from "../dropComponent/DropComponentTest";
import {MdExpandLess, MdExpandMore} from "react-icons/md";

const TestSection = ({
                         currentData,
                         extractionId,
                         setSelectedTestFiles,
                         selectedTestFiles,
                         testResult,
                         setTestResult,
                         showResult,
                         setShowResult,
                         currentView,
                         setCurrentView
                     }) => {
    const [isUploading, setUploading] = useState(false);
    const [images, setImages] = useState([])
    const [layouts, setLayouts] = useState(null)
    const [currentPage, setCurrentPage] = useState(0)

    const [isUploadOpen, setIsUploadOpen] = useState(true);
    const toggleCollapse = () => setIsUploadOpen(!isUploadOpen);

    useEffect(() => {
        if (selectedTestFiles.length) {
            const file = selectedTestFiles[0]
            if (file.type === 'application/pdf') {
                const getImages = async () => await pdf2Images(file)
                getImages().then(r => setImages(r))
            } else if (file.type.startsWith('image')) {
                imageReader(file).then(r => setImages(r))
            } else {
                setImages([])
            }
            setTestResult(null)
        }
    }, [selectedTestFiles, setTestResult]);

    useEffect(() => {
        if (testResult) {
            setIsUploadOpen(false)
            setLayouts(testResult.map(v => v['layouts']).flat())
        } else {
            setLayouts(null)
            setCurrentView({page: null, layout: null})
            setCurrentPage(0)
        }
    }, [testResult, setCurrentView]);

    const onClickHandler = useCallback((page, layout) => {
        if (currentView.page === page && currentView.layout === layout) setCurrentView({page: null, layout: null})
        else setCurrentView({page: page, layout: layout})
    }, [currentView, setCurrentView])

    useEffect(() => {
        if (currentView.page !== null) setCurrentPage(currentView.page)
    }, [currentView]);

    return (
        <div className={'h-full flex flex-col'}>
            <div className="h-8 min-h-8 px-3 mt-1 text-xs font-medium text-gray-700 flex justify-between items-center">
                <div className={'h-full flex items-center'}>
                    <p>TEST TEMPLATE</p>
                    <button onClick={toggleCollapse}
                            className="mx-2 px-2 h-full text-gray-500 bg-gray-100 hover:bg-gray-200 transition-colors duration-200 rounded-lg flex items-center justify-between">
                        <span className={''}>Upload</span>
                        <span className={'ml-1'}>
                            {isUploadOpen ? <MdExpandMore size={16}/> : <MdExpandLess size={16}/>}
                        </span>
                    </button>
                </div>
                {!showResult && testResult &&
                    <button className={'text-white bg-green-600 hover:bg-green-700 rounded-lg px-4 h-full'}
                            onClick={() => setShowResult(true)}>Show Result</button>}
            </div>
            <div className={`max-w-80 min-w-80 px-3 mt-1 transition-all duration-300 ease-in-out ${
                isUploadOpen ? 'max-h-full opacity-100' : 'max-h-0 opacity-0 pointer-events-none'
            }`}>
                <DropComponentTest
                    selectedTestFiles={selectedTestFiles}
                    setSelectedTestFiles={setSelectedTestFiles}
                    currentData={currentData}
                    isUploading={isUploading}
                    setUploading={setUploading}
                    setTestResult={setTestResult}
                    extractionId={extractionId}
                />
            </div>
            {Boolean(images.length) &&
                <div className={'flex-1 relative flex justify-center px-3 overflow-y-hidden'}>
                    <div className={'relative h-full overflow-y-hidden hover:overflow-y-scroll'}
                         style={{scrollbarGutter: 'stable'}}>
                        <div className={'relative mt-5'}>
                            <img src={images[currentPage]} alt={''}/>
                            {layouts?.[currentPage].map((box, index) => {
                                const [x1, y1, x2, y2] = box['normalized_box']
                                const key = `${box['normalized_box']}`;
                                const isDuplicate = layouts[currentPage].findIndex(b => {
                                    return `${b['normalized_box']}` === key
                                }) !== index;
                                return (
                                    <div
                                        key={index}
                                        className={`absolute border-2 group opacity-0 hover:opacity-100 ${(currentView.page === currentPage && currentView.layout === index) || currentView.layout === null ? 'opacity-100' : ''}`}
                                        style={{
                                            left: `${x1 * 100}%`,
                                            top: `${y1 * 100}%`,
                                            width: `${(x2 - x1) * 100}%`,
                                            height: `${(y2 - y1) * 100}%`,
                                            borderColor: 'green',
                                            backgroundColor: 'rgba(0, 128, 0, 0.05)',
                                            display: isDuplicate && currentView.layout !== index ? 'none' : 'block',
                                        }}
                                        onClick={() => onClickHandler(currentPage, index)}
                                    >
                                        <div
                                            className="absolute -top-5 px-1 -left-0.5 hidden group-hover:block rounded text-sm text-white capitalize text-nowrap"
                                            style={{backgroundColor: 'green'}}>
                                            {index + 1}. {box['layout_type']}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="absolute bg-black bg-opacity-40 rounded-lg">
                        <ImageViewControl
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            numPages={images.length}
                        />
                    </div>
                </div>}
        </div>
    );
};

export default TestSection;
